<template>
  <v-dialog
    v-model="showExport"
    max-width="1000px"
    scrollable
    @keydown.enter="validate()"
    @keydown.esc="showExport = false"
  >
    <v-card v-if="showExport" outlined>
      <v-card-title class="pt-0" style="justify-content: center; height: 70px">{{ modalTitle }}</v-card-title>
      <v-card-text class="pb-0 pt-1">
        <validation-observer ref="form">
          <v-form>
            <v-col cols="12">
              <validation-provider v-slot="{ errors }" :name="$t('exportCsv.csvName')" rules="required">
                <v-select
                  v-model="fields.value"
                  :error-messages="errors"
                  :items="fields.arrayValues"
                  :label="fields.text"
                  dense
                  multiple
                >
                  <v-list-item slot="prepend-item" ripple @click.stop="selectAllFields()">
                    <v-list-item-action>
                      <v-icon v-if="!selectedAll" color="primary darken-2">mdi-select</v-icon>
                      <v-icon v-else color="primary darken-1">mdi-select-all</v-icon>
                    </v-list-item-action>
                    <v-list-item-title v-if="!selectedAll">{{ $t('exportCsv.selectAll') }}</v-list-item-title>
                    <v-list-item-title v-else>{{ $t('exportCsv.removeAll') }}</v-list-item-title>
                  </v-list-item>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0" small> {{ item.text }} </v-chip>
                    <span v-if="index === 1" class="grey--text caption">
                      (+{{ fields.value.length - 1 }} {{ $t('exportCsv.other') }})
                    </span>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>
            <v-col v-if="exportLineItems" cols="12">
              <validation-provider v-slot="{ errors }" :name="$t('exportCsv.csvNameItem')" rules="required">
                <v-select
                  v-model="itemsFields.value"
                  :error-messages="errors"
                  :items="itemsFields.arrayValues"
                  :label="itemsFields.text"
                  dense
                  multiple
                >
                  <v-list-item slot="prepend-item" ripple @click.stop="selectAllItemsFields()">
                    <v-list-item-action>
                      <v-icon v-if="!selectAllItems" color="primary darken-2">mdi-select</v-icon>
                      <v-icon v-else color="primary darken-1">mdi-select-all</v-icon>
                    </v-list-item-action>
                    <v-list-item-title v-if="!selectAllItems">{{ $t('exportCsv.selectAll') }}</v-list-item-title>
                    <v-list-item-title v-else>{{ $t('exportCsv.removeAll') }}</v-list-item-title>
                  </v-list-item>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0" small> {{ item.text }} </v-chip>
                    <span v-if="index === 1" class="grey--text caption">
                      (+{{ itemsFields.value.length - 1 }} {{ $t('exportCsv.other') }})
                    </span>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>
            <v-col v-if="exportPayments" cols="12">
              <validation-provider v-slot="{ errors }" :name="$t('exportCsv.csvPaymentsFieldsExport')" rules="required">
                <v-select
                  v-model="csvPaymentsFields.value"
                  :error-messages="errors"
                  :items="csvPaymentsFields.arrayValues"
                  :label="csvPaymentsFields.text"
                  dense
                  multiple
                >
                  <v-list-item slot="prepend-item" ripple @click.stop="selectAllCsvPaymentsFields()">
                    <v-list-item-action>
                      <v-icon v-if="!selectAllPaymentsFields" color="primary darken-2">mdi-select</v-icon>
                      <v-icon v-else color="primary darken-1">mdi-select-all</v-icon>
                    </v-list-item-action>
                    <v-list-item-title v-if="!selectAllPaymentsFields">{{ $t('exportCsv.selectAll') }}</v-list-item-title>
                    <v-list-item-title v-else>{{ $t('exportCsv.removeAll') }}</v-list-item-title>
                  </v-list-item>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0" small> {{ item.text }} </v-chip>
                    <span v-if="index === 1" class="grey--text caption">
                      (+{{ csvPaymentsFields.value.length - 1 }} {{ $t('exportCsv.other') }})
                    </span>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>
          </v-form>
        </validation-observer>
        <v-col cols="12">
          <v-checkbox v-model="exportLineItems" :label="$t('exportCsv.toItemLine')"></v-checkbox>
          <v-checkbox
            v-model="exportCustomItemFields"
            v-if="exportLineItems"
            :label="$t('exportCsv.itemCustomField')"
          />
          <v-checkbox v-if="csvPaymentsFields" v-model="exportPayments" :label="$t('exportCsv.exportPayments')"></v-checkbox>
          <v-checkbox v-model="exportCustomFields" :label="$t('exportCsv.custom')"></v-checkbox>
        </v-col>
      </v-card-text>
      <v-card-actions style="justify-content: center; height: 70px">
        <v-row class="d-flex flex-row justify-center ma-1">
          <v-btn class="mr-4" color="primary" outlined @click="validate()">{{ $t('subOrder.validate') }}</v-btn>
          <v-btn class="mr-4" color="primary" outlined @click="resetField()">{{ $t('subOrder.close') }}</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'

  export default {
    name: 'exportFieldsDialog',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data() {
      return {
        selectedAll: false,
        selectAllItems: false,
        selectAllPaymentsFields: false,
        exportLineItems: false,
        exportPayments: false,
        exportCustomFields: false,
        exportCustomItemFields: false,
      }
    },
    props: {
      title: {
        type: String,
        default: undefined,
      },
      value: {
        type: Boolean,
        default: false,
      },
      fields: {
        type: Object,
        required: true,
      },
      itemsFields: {
        type: Object,
      },
      csvPaymentsFields: {
        type: Object
      }
    },
    computed: {
      showExport: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      modalTitle: function () {
        if (this.title) {
          return this.title
        } else return this.$t('subOrder.toFilter')
      },
    },
    methods: {
      resetField() {
        this.showExport = false
        this.$refs.form.reset()
        this.selectedAll = false
        this.fields.value = []
        this.itemsFields.value = []
        this.csvPaymentsFields.value = []
        this.selectAllItems = false
        this.selectAllPaymentsFields = false
        this.exportLineItems = false
        this.exportCustomFields = false
        this.exportCustomItemFields = false
        this.exportPayments = false
      },
      selectAllFields() {
        this.selectedAll = !this.selectedAll
        if (this.selectedAll) {
          this.fields.value = this.fields.arrayValues.map((item) => item.value)
        } else {
          this.fields.value = []
        }
      },
      selectAllItemsFields() {
        this.selectAllItems = !this.selectAllItems
        if (this.selectAllItems) {
          this.itemsFields.value = this.itemsFields.arrayValues.map((item) => item.value)
        } else {
          this.itemsFields.value = []
        }
      },
      selectAllCsvPaymentsFields() {
        this.selectAllPaymentsFields = !this.selectAllPaymentsFields
        if (this.selectAllPaymentsFields) {
          this.csvPaymentsFields.value = this.csvPaymentsFields.arrayValues.map((item) => item.value)
        } else {
          this.csvPaymentsFields.value = []
        }
      },
      validate() {
        this.$refs.form.validate().then((success) => {
          if (success) {
            if (this.exportLineItems) {
              this.fields.value = this.fields.value.concat(this.itemsFields.value)
            }
            if(this.exportPayments) {
              this.fields.value = this.fields.value.concat(this.csvPaymentsFields.value)
            }
            this.$emit('exportCSV', {
              csvHeadersToExport: this.fields.value,
              exportItemsLine: this.exportLineItems,
              exportCustomFields: this.exportCustomFields,
              exportCustomItemFields: this.exportCustomItemFields,
            })
            this.showExport = false
            this.resetField()
            this.selectedAll = false
          }
        })
      },
    },
  }
</script>

<style></style>
